module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00455.e10339ea.jpg";